(ns nosco.colors
  #?(:clj (:require
           [clojure.string :as string]
           [nosco.figma-utils :refer [defmap]])
     :cljs (:require-macros [nosco.figma-utils :refer [defmap]])))

(defmap colors
  {blue-50 "#EFF4FE"
   blue-100 "#E5EEFF"
   blue-200 "#CDDEFF"
   blue-300 "#B1CBFC"
   blue-400 "#8DAEFC"
   blue-500 "#5083FA"
   blue-600 "#3D73F2"
   blue-700 "#2E65E5"
   blue-800 "#2959CC"
   blue-900 "#050E54"

   green-50 "#EAFBF4"
   green-100 "#B4ECCD"
   green-200 "#7DDFAD"
   green-300 "#28D28C"
   green-400 "#27C486"
   green-500 "#20BA87"
   green-600 "#1AAB7B"
   green-700 "#0F996B"
   green-800 "#07875C"
   green-900 "#056746"

   neutral-10 "#F6F7F8"
   neutral-20 "#F0F2F5"
   neutral-100 "#E4E6EB"
   neutral-200 "#D7DAE0"
   neutral-300 "#C0C3CC"
   neutral-400 "#878B99"
   neutral-500 "#72778A"
   neutral-600 "#606378"
   neutral-700 "#474B5E"
   neutral-800 "#36394D"
   neutral-900 "#26273B"

   white "#FFFFFF"

   info-50 "#EFEAF8"
   info-100 "#D1C5E9"
   info-300 "#A891D7"
   info-400 "#7D5AC3"
   info-500 "#663EB8"
   info-600 "#5D39B2"
   info-800 "#442BA1"

   ;; TODO: Figma "Critical" palette has different values — check if error-* should be updated:
   ;; Figma: 900=#92003D, 800=#B40041, 700=#C70A43, 600=#DC1445, 500=#EC1B46,
   ;;        400=#F13C60, 300=#F65E7B, 200=#F096A2, 100=#FECBD7, 50=#FFEAF0
   error-50 "#FFF7F9"
   error-100 "#FABDD3"
   error-300 "#F56798"
   error-400 "#F24681"
   error-500 "#F0286B"
   error-600 "#DF2567"
   error-800 "#B31D5E"

   success-50 "#E7F8F3"
   success-100 "#B9E4D1"
   success-300 "#53C397"
   success-400 "#11B683"
   success-500 "#00A96C"
   success-600 "#009A61"
   success-800 "#007748"

   warning-50 "#FEF8E4"
   warning-100 "#FDEAB3"
   warning-300 "#FBD14F"
   warning-400 "#FAC62A"
   warning-500 "#F9AF08"
   warning-700 "#F99C07"
   warning-900 "#9F4F09"

   ;; Accent colors — from Figma Accent color variables
   ;; 9 hue families × 13 shades (1000, 900, 850, 800, 700, 600, 500, 400, 300, 250, 200, 100)
   accent-blue-1000 "#1C2B42"
   accent-blue-900 "#123263"
   accent-blue-850 "#144794"
   accent-blue-800 "#1558BC"
   accent-blue-700 "#1868DB"
   accent-blue-600 "#357DE8"
   accent-blue-500 "#4688EC"
   accent-blue-400 "#669DF1"
   accent-blue-300 "#8FB8F6"
   accent-blue-250 "#ADCBFB"
   accent-blue-200 "#CFE1FD"
   accent-blue-100 "#E9F2FE"

   accent-teal-1000 "#1E3137"
   accent-teal-900 "#164555"
   accent-teal-850 "#1A5265"
   accent-teal-800 "#206A83"
   accent-teal-700 "#227D9B"
   accent-teal-600 "#2898BD"
   accent-teal-500 "#42B2D7"
   accent-teal-400 "#6CC3E0"
   accent-teal-300 "#9DD9EE"
   accent-teal-250 "#B1E4F7"
   accent-teal-200 "#C6EDFB"
   accent-teal-100 "#E7F9FF"

   accent-green-1000 "#1C3324"
   accent-green-900 "#164B28"
   accent-green-850 "#19572E"
   accent-green-800 "#216E3B"
   accent-green-700 "#1F8441"
   accent-green-600 "#22A04C"
   accent-green-500 "#2ABB5A"
   accent-green-400 "#4BCE72"
   accent-green-300 "#7EE29C"
   accent-green-250 "#97EDB1"
   accent-green-200 "#BAF3CB"
   accent-green-100 "#DCFFE7"

   accent-lime-1000 "#28311B"
   accent-lime-900 "#37471F"
   accent-lime-850 "#3F5224"
   accent-lime-800 "#4C6B1F"
   accent-lime-700 "#5B7F24"
   accent-lime-600 "#6A9A23"
   accent-lime-500 "#82B536"
   accent-lime-400 "#94C748"
   accent-lime-300 "#B3DF72"
   accent-lime-250 "#BDE97C"
   accent-lime-200 "#D3F1A7"
   accent-lime-100 "#EFFFD6"

   accent-yellow-1000 "#332E1B"
   accent-yellow-900 "#533F04"
   accent-yellow-850 "#614A05"
   accent-yellow-800 "#7F5F01"
   accent-yellow-700 "#946F00"
   accent-yellow-600 "#B38600"
   accent-yellow-500 "#CF9F02"
   accent-yellow-400 "#DDB30E"
   accent-yellow-300 "#EED12B"
   accent-yellow-250 "#EFDD4E"
   accent-yellow-200 "#F5E989"
   accent-yellow-100 "#FEF7C8"

   accent-orange-1000 "#3A2C1F"
   accent-orange-900 "#693200"
   accent-orange-850 "#7A3B00"
   accent-orange-800 "#9E4C00"
   accent-orange-700 "#BD5B00"
   accent-orange-600 "#E06C00"
   accent-orange-500 "#F68909"
   accent-orange-400 "#FCA700"
   accent-orange-300 "#FBC828"
   accent-orange-250 "#FBD779"
   accent-orange-200 "#FCE4A6"
   accent-orange-100 "#FFF5DB"

   accent-red-1000 "#42221F"
   accent-red-900 "#5D1F1A"
   accent-red-850 "#872821"
   accent-red-800 "#AE2E24"
   accent-red-700 "#C9372C"
   accent-red-600 "#E2483D"
   accent-red-500 "#F15B50"
   accent-red-400 "#F87168"
   accent-red-300 "#FD9891"
   accent-red-250 "#FFB8B2"
   accent-red-200 "#FFD5D2"
   accent-red-100 "#FFECEB"

   accent-magenta-1000 "#3D2232"
   accent-magenta-900 "#50253F"
   accent-magenta-850 "#77325B"
   accent-magenta-800 "#943D73"
   accent-magenta-700 "#AE4787"
   accent-magenta-600 "#CD519D"
   accent-magenta-500 "#DA62AC"
   accent-magenta-400 "#E774BB"
   accent-magenta-300 "#F797D2"
   accent-magenta-250 "#FCB6E1"
   accent-magenta-200 "#FDD0EC"
   accent-magenta-100 "#FFECF8"

   accent-purple-1000 "#2D243F"
   accent-purple-900 "#37245D"
   accent-purple-850 "#4E3286"
   accent-purple-800 "#613FA5"
   accent-purple-700 "#734AC0"
   accent-purple-600 "#8659E1"
   accent-purple-500 "#9863F3"
   accent-purple-400 "#A87CF4"
   accent-purple-300 "#C0A0F7"
   accent-purple-250 "#D1BDFA"
   accent-purple-200 "#E3D7FC"
   accent-purple-100 "#F4EEFE"

   ;; Heatmap colors for conditional formatting
   ;; These are aliases of accent colors: accent-red-300, accent-orange-250, accent-green-300
   heatmap-red "#FD9891"
   heatmap-yellow "#FBD779"
   heatmap-green "#7EE29C"})

;; ---------------------------------------------------------------------------
;; Accent color palette — organized by hue family
;; ---------------------------------------------------------------------------

(def accent-hues
  "Ordered vector of accent hue keywords, matching the color picker column order.
   :black is a true neutral grayscale (not blue-tinted like the neutral-* palette)."
  [:black :blue :teal :green :lime :yellow :orange :red :magenta :purple])

(def accent-shades
  "Ordered vector of accent shade levels, from darkest to lightest."
  [1000 900 850 800 700 600 500 400 300 250 200 100])

(def accent-palette
  "Map of {hue → {shade → hex-string}} for all accent colors.
   :black is a true neutral grayscale from the Figma Accent Colours palette."
  {:black   {1000 "#1e1f21", 900 "#292a2e", 850 "#3b3d42"
             800 "#505258", 700 "#6b6e76", 600 "#7d818a"
             500 "#8c8f97", 400 "#b7b9be", 300 "#dddee1"
             250 "#f0f1f2", 200 "#f8f8f8", 100 "#ffffff"}
   :blue    {1000 accent-blue-1000, 900 accent-blue-900, 850 accent-blue-850
             800 accent-blue-800, 700 accent-blue-700, 600 accent-blue-600
             500 accent-blue-500, 400 accent-blue-400, 300 accent-blue-300
             250 accent-blue-250, 200 accent-blue-200, 100 accent-blue-100}
   :teal    {1000 accent-teal-1000, 900 accent-teal-900, 850 accent-teal-850
             800 accent-teal-800, 700 accent-teal-700, 600 accent-teal-600
             500 accent-teal-500, 400 accent-teal-400, 300 accent-teal-300
             250 accent-teal-250, 200 accent-teal-200, 100 accent-teal-100}
   :green   {1000 accent-green-1000, 900 accent-green-900, 850 accent-green-850
             800 accent-green-800, 700 accent-green-700, 600 accent-green-600
             500 accent-green-500, 400 accent-green-400, 300 accent-green-300
             250 accent-green-250, 200 accent-green-200, 100 accent-green-100}
   :lime    {1000 accent-lime-1000, 900 accent-lime-900, 850 accent-lime-850
             800 accent-lime-800, 700 accent-lime-700, 600 accent-lime-600
             500 accent-lime-500, 400 accent-lime-400, 300 accent-lime-300
             250 accent-lime-250, 200 accent-lime-200, 100 accent-lime-100}
   :yellow  {1000 accent-yellow-1000, 900 accent-yellow-900, 850 accent-yellow-850
             800 accent-yellow-800, 700 accent-yellow-700, 600 accent-yellow-600
             500 accent-yellow-500, 400 accent-yellow-400, 300 accent-yellow-300
             250 accent-yellow-250, 200 accent-yellow-200, 100 accent-yellow-100}
   :orange  {1000 accent-orange-1000, 900 accent-orange-900, 850 accent-orange-850
             800 accent-orange-800, 700 accent-orange-700, 600 accent-orange-600
             500 accent-orange-500, 400 accent-orange-400, 300 accent-orange-300
             250 accent-orange-250, 200 accent-orange-200, 100 accent-orange-100}
   :red     {1000 accent-red-1000, 900 accent-red-900, 850 accent-red-850
             800 accent-red-800, 700 accent-red-700, 600 accent-red-600
             500 accent-red-500, 400 accent-red-400, 300 accent-red-300
             250 accent-red-250, 200 accent-red-200, 100 accent-red-100}
   :magenta {1000 accent-magenta-1000, 900 accent-magenta-900, 850 accent-magenta-850
             800 accent-magenta-800, 700 accent-magenta-700, 600 accent-magenta-600
             500 accent-magenta-500, 400 accent-magenta-400, 300 accent-magenta-300
             250 accent-magenta-250, 200 accent-magenta-200, 100 accent-magenta-100}
   :purple  {1000 accent-purple-1000, 900 accent-purple-900, 850 accent-purple-850
             800 accent-purple-800, 700 accent-purple-700, 600 accent-purple-600
             500 accent-purple-500, 400 accent-purple-400, 300 accent-purple-300
             250 accent-purple-250, 200 accent-purple-200, 100 accent-purple-100}})

;; ---------------------------------------------------------------------------
;; Picker-specific helpers (exclude yellow — too close to orange)
;; ---------------------------------------------------------------------------

(def picker-hues
  "Hues shown in the color picker (accent-hues minus :yellow)"
  [:blue :teal :green :lime :orange :red :magenta :purple])

(defn picker-row
  "Like `accent-row` but excludes yellow — returns 9 colors for the picker."
  [shade]
  (mapv (fn [hue] (get-in accent-palette [hue shade])) picker-hues))

(def category-colors
  "The 8 picker accent colors at shade 600 (no yellow).
   Used as the default categorical top row and for accent-color-for."
  (picker-row 600))

(defn data-color-for
  "Returns a deterministic accent color for `seed` from the picker-600 row (no yellow)."
  [seed]
  (nth category-colors (mod (hash seed) (count category-colors))))

;; ---------------------------------------------------------------------------
;; Picker grid construction
;; ---------------------------------------------------------------------------

(def picker-all-shades
  "The 5 shade levels available in the color picker, darkest to lightest."
  [850 700 600 300 200])

(def picker-neutral-column
  "Neutral colors used as the last column in the picker, darkest to lightest.
   One neutral per shade row: 850→neutral-900, 700→neutral-600, 600→neutral-400,
   300→neutral-200, 200→white."
  [neutral-900 neutral-600 neutral-400 neutral-200 white])

(defn picker-rows
  "Returns a 5×9 grid of picker colors with a promoted shade as the first row.
   The promoted row appears first, followed by the remaining rows in their
   original order (darkest to lightest). Each row has 8 hue colors + 1 neutral = 9 columns.

   color-scheme controls which shade is promoted:
   - :categories (default) — promotes shade 600 (vivid accent colors)
   - :conditional — promotes shade 300 (lighter, used for heatmaps/evaluations)"
  ([] (picker-rows :categories))
  ([color-scheme]
   (let [promoted-shade (case color-scheme
                          :categories 600
                          :conditional 300)
         shade->neutral (zipmap picker-all-shades picker-neutral-column)
         make-row (fn [shade]
                    (conj (picker-row shade) (get shade->neutral shade)))
         promoted-row (make-row promoted-shade)
         remaining-rows (mapv make-row (remove #{promoted-shade} picker-all-shades))]
     (into [promoted-row] remaining-rows))))

(def border-secondary neutral-300)
(def border-primary neutral-100)
(def fill-secondary neutral-20)
(def border-success success-600)
(def border-error error-500)
(def border-warning warning-700)
(def text-primary neutral-900)

(def icon-success success-600)
(def icon-error error-600)
(def icon-warning warning-700)

#?(:clj (defn- colors-scss []
          (let [colors* (sort-by key colors)]
            (str
             "// GENERATED BY nosco.colors\n\n"
             (->> colors*
                  (map (fn [[k v]] (format "$color-%s: %s;" k v)))
                  (string/join "\n"))
             "\n\n"
             "$nosco-colors: (\n"
             (->> colors*
                  (map (fn [[k _v]] (format "  \"%s\": $color-%s" k k)))
                  (string/join ",\n"))
             "\n);"))))

#?(:clj (defn export-colors-to-scss! [output-path]
          (spit output-path (str (colors-scss) "\n"))))

(comment

  (export-colors-to-scss! "scss/_colors.scss"))
